import { ARTIFACT_LABEL } from '../../constants'

export const ACTIVE_CAMPAIGNS = ['lr_dsa_pecas', 'lr_dsa_assuntos_juridicos'] as const
export const EXCLUDED_ARTIFACTS_FROM_PPC_LOCK = [
  ARTIFACT_LABEL.ARTIGO,
  ARTIFACT_LABEL.NOTICIAS,
  ARTIFACT_LABEL.DOUTRINA,
  ARTIFACT_LABEL.SECAO_DOUTRINA,
] as const
export const viewContentFeatureCode = 'view_lr_content'

export const LockType = {
  LOGGED: 'logged',
  UNLOGGED: 'unlogged',
  LAWYER: 'lawyer',
  OAB: 'oab',
}
